/**
 * Namibian dollar.
 */
export var NAD = {
  code: 'NAD',
  base: 10,
  exponent: 2
};